<script setup lang="ts">
const props = defineProps<{
  code: string;     // flagcdn alpha-2 (or region) code
  size?: "sm" | "md" | "lg";
  name?: string;    // optional tooltip
}>();

const url = (variant: "w80" | "h120") => `https://flagcdn.com/${variant}/${props.code}.png`;
</script>

<template>
  <img
    :src="props.size === 'lg' ? url('h120') : url('w80')"
    :alt="props.name ?? props.code"
    :title="props.name"
    loading="lazy"
    decoding="async"
    :class="[
      'inline-block rounded-sm object-cover ring-1 ring-slate-300/80 shadow-sm',
      props.size === 'sm' && 'h-4 w-6',
      (!props.size || props.size === 'md') && 'h-6 w-9',
      props.size === 'lg' && 'h-16 w-24',
    ]"
  />
</template>
